import React, { Component } from "react";
import { connect } from "react-redux";

import { Container, KeyboardView } from "app/NativeComponents/common";
import {
  Header,
  NewHeader,
  SelectItem,
  SmallLabel
} from "app/NativeComponents/snippets";

import Body from "./Body";

import {
  updateUser,
  popSidePanel,
  /*common functions*/
  dismissMobileKeyboard
} from "app/NativeActions";

class EditUserPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        ...props.user,
        new_password: "",
        new_password_confirm: "",
        old_password: ""
      },
      loading: false
    };

    this.saveUserInfo = this.saveUserInfo.bind(this);
    this.checkIfNeedsToSave = this.checkIfNeedsToSave.bind(this);
    this.updateUserFieldChange = this.updateUserFieldChange.bind(this);
  }

  checkIfNeedsToSave() {
    if (
      this.state.user.new_password == this.state.user.new_password_confirm &&
      !!this.state.user.new_password &&
      !!this.state.user.new_password_confirm &&
      !!this.state.user.old_password
    ) {
      return true;
    }

    return false;
  }

  updateUserFieldChange({ prop, value }) {
    this.setState({
      user: {
        ...this.state.user,
        [prop]: value
      }
    });
  }

  handleBack() {
    dismissMobileKeyboard();
    this.props.popSidePanel();
  }

  saveUserInfo() {
    /*mobile*/
    dismissMobileKeyboard();

    const { new_password, new_password_confirm, old_password } =
      this.state.user;
    this.props.updateUser({
      token: this.props.token,
      type: "change_password",
      payload: {
        new_password,
        new_password_confirm,
        old_password
      },
      onLoading: () => {
        this.setState({
          loading: true
        });
      },
      onError: () => {
        this.setState({
          loading: false
        });
      },
      onSuccess: () => {
        this.setState({
          loading: false
        });

        this.handleBack();
      }
    });
  }

  render() {
    return (
      <Container>
        <NewHeader
          title="Change Password"
          leftButton={{
            icon: "arrow-back",
            onPress: () => {
              this.handleBack();
            }
          }}
        />
        <KeyboardView style={{ flex: 1 }}>
          <Body
            {...this.props}
            editUser={this.state.user}
            loading={this.state.loading}
            saveUserInfo={this.saveUserInfo}
            checkIfNeedsToSave={this.checkIfNeedsToSave}
            updateUserFieldChange={this.updateUserFieldChange}
          />
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings }) => {
  const { token, user } = auth;
  const { device } = native;
  const { colors } = settings;

  return { token, user, device, colors };
};

export default connect(mapStateToProps, {
  updateUser,
  popSidePanel
})(EditUserPassword);
